import { Neon, TNeon } from "../Neon/Neon";

import "./avatar.scss";

export interface IAvatar {
  color: TNeon["color"];
  avatar: string;
  className?: string;
}

export const Avatar = ({ color, avatar, className }: IAvatar): JSX.Element => {
  return (
    <div className={`avatar ${className}`}>
      <Neon color={color} />
      <img className='avatar-bg-neon' src={avatar} alt='avatar' />
    </div>
  );
};
